//frontend/src/components/WalletRechargeComponents.jsx
import React, { useState } from 'react';
import './PaymentComponent.css';
import paymentGatewayOptions from './PaymentGateway.json';
import paymentModeOptions from './PaymentMode.json';
import WalletRechargeInitiated from './WalletRechargeInitiated';

const WalletRechargeComponent = ({ onClose, loggedInUserName, selectedAmount  }) => {
    const [customerName, setCustomerName] = useState(loggedInUserName);
    const [amount, setAmount] = useState(selectedAmount);
    const [selectedPaymentGateway, setSelectedPaymentGateway] = useState('');
    const [selectedPaymentMode, setSelectedPaymentMode] = useState('');
    const [gatewayError, setGatewayError] = useState('');
    const [modeError, setModeError] = useState('');

    const [showWalletRechargeInitiated, setShowWalletRechargeInitiated] = useState(false);


    const handlePayNow = () => {
        let hasError = false;
        if (!selectedPaymentGateway) {
            setGatewayError('Please select Payment Gateway');
            hasError = true;
        } else {
            setGatewayError('');
        }
        if (!selectedPaymentMode) {
            setModeError('Please select Payment Mode');
            hasError = true;
        } else {
            setModeError('');
        }
        if (hasError) {
            return;
        }
        setShowWalletRechargeInitiated(true);
        // onclose();
    };
    
   
    if (showWalletRechargeInitiated) {
        return (
            <WalletRechargeInitiated
                paymentDetails={{
                    customerName,
                    amount: selectedAmount,
                    paymentGateway: selectedPaymentGateway,
                    paymentMode: selectedPaymentMode,
                }}
            />
        );
    }

    return (
        <div className="payment-form">
            <h2>Details</h2>
            <label htmlFor="customerName">Name:</label>
            <input type="text" id="customerName" value={customerName} onChange={e => setCustomerName(e.target.value)} />
            <label htmlFor="amount">Amount:</label>
            <input type="text" id="amount" value={amount} readOnly />
            <label htmlFor="paymentGateway">Payment Gateway:</label>
            <select className="select" id="paymentGateway" value={selectedPaymentGateway} onChange={e => setSelectedPaymentGateway(e.target.value)}>
                <option value="">Select Payment Gateway</option>
                {paymentGatewayOptions.map(option => (
                    <option key={option.id} value={option.name}>{option.name}</option>
                ))}
            </select>
            {gatewayError && <span className="error">{gatewayError}</span>}
            <label htmlFor="paymentMode">Payment Mode:</label>
            <select id="paymentMode" value={selectedPaymentMode} onChange={e => setSelectedPaymentMode(e.target.value)}>
                <option value="">Select Payment Mode</option>
                {paymentModeOptions.map(option => (
                    <option key={option.id} value={option.name}>{option.name}</option>
                ))}
            </select>
            {modeError && <span className="error">{modeError}</span>}
            <div className="buttons">
                <button onClick={onClose}>Change Amount</button>
                <button onClick={handlePayNow}>Pay Now</button>
            </div>
        </div>
    );
};

export default WalletRechargeComponent;
